import Api from './Api';

class GoogleDriveApi extends Api {
  url = 'google/drives';
}

const singleton = new GoogleDriveApi();
export default singleton;
